import CONST_STORAGE from 'constants/storage';

export const setTotalScroll = (total: number) =>
  localStorage.setItem(CONST_STORAGE.DRAWER.TOTAL_SCROLL, `${total}`);

export const getTotalScroll = () =>
  localStorage.getItem(CONST_STORAGE.DRAWER.TOTAL_SCROLL);

export const setItemOpen = (item: string) =>
  localStorage.setItem(CONST_STORAGE.DRAWER.ITEM_OPEN, item);

export const getItemOpen = () =>
  localStorage.getItem(CONST_STORAGE.DRAWER.ITEM_OPEN);

export const removeItemOpen = () =>
  localStorage.removeItem(CONST_STORAGE.DRAWER.ITEM_OPEN);

export const setCurrentPath = (path: string) =>
  sessionStorage.setItem(CONST_STORAGE.DRAWER.CURRENT_PATH, path);

export const getCurrentPath = () =>
  sessionStorage.getItem(CONST_STORAGE.DRAWER.CURRENT_PATH);
